// extracted by mini-css-extract-plugin
export var activeDot = "_6y-c";
export var buttonContainer = "_6y-9";
export var channelButton = "_6y-a";
export var clickable = "_6y-d";
export var content = "_6y-0";
export var contentFull = "_6y-2";
export var contentThird = "_6y-1";
export var contentWrapper = "_6y-7";
export var description = "_6y-5";
export var heightShort = "_6y-f";
export var image = "_6y-3";
export var imageContainer = "_6y-4";
export var selectButton = "_6y-e";
export var spinnerContainer = "_6y-b";
export var titleContent = "_6y-8";
export var titleWrapper = "_6y-6";